import { Box, Typography, Container } from '@mui/material';

const SectionBlock = ({
  children,
  bgcolor = 'background.paper',
  maxWidth = 'md',
  fullWidth = false,
  py = { xs: 6, md: 10 },
  title,
  subtitle,
  align = 'center', // 'center' | 'left' | 'right'
  ...rest
}) => (
  <Box
    sx={{
      bgcolor,
      py,
      width: '100%',
      ...rest.sx,
    }}
  >
    {fullWidth ? (
      <>
        {(title || subtitle) && (
          <Container maxWidth={maxWidth}>
            <Box mb={4} textAlign={align}>
              {title && (
                <Typography
                  variant="h3"
                  fontWeight={800}
                  color="primary.main"
                  gutterBottom
                >
                  {title}
                </Typography>
              )}
              {subtitle && (
                <Typography
                  variant="h6"
                  color="text.secondary"
                  sx={{ maxWidth: 600, mx: align === 'center' ? 'auto' : undefined }}
                >
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Container>
        )}
        {children}
      </>
    ) : (
      <Container maxWidth={maxWidth}>
        {(title || subtitle) && (
          <Box mb={4} textAlign={align}>
            {title && (
              <Typography
                variant="h3"
                fontWeight={800}
                color="primary.main"
                gutterBottom
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography
                variant="h6"
                color="text.secondary"
                sx={{ maxWidth: 600, mx: align === 'center' ? 'auto' : undefined }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        )}
        {children}
      </Container>
    )}
  </Box>
);

export default SectionBlock; 